import React from "react";
import {
  Datagrid,
  DateField,
  Filter,
  ImageField,
  SearchInput,
  ImageInput,
  List,
  NumberInput,
  ReferenceField,
  SelectInput,
  SimpleShowLayout,
  TextField,
  ReferenceInput,
  TextInput,  required,
  BooleanInput,
  SimpleFormIterator,
  ArrayInput,
  Edit,
  SimpleForm,
  BooleanField,
} from "react-admin";

import CreateView from "../../components/CreateView";
import ShowView from "../../components/ShowView";
import { isMobile } from 'react-device-detect';
import { makeStyles } from "@material-ui/core/styles";
import { Divider } from "@material-ui/core";
import EditActions from "../../components/EditActions";
import { EditFormActions } from "../../components/FormActions";
export const useDividerStyleList = makeStyles(
  theme => ({
    root: {
      height: "3px", width: "100%", backgroundColor: "#cd8a8a"
    },
  }),
  { name: 'MuiDivider' }
);
export const useSimpleFormStyleList =
  makeStyles(
    theme => ({
      root: {
        padding: 0,
        marginBottom: 0,
        width: '90%',
        '& > li:last-child': {
          borderBottom: 'none',
        },
      },
      line: {
        display: 'flex',
        marginTop: '16px',
        listStyleType: 'none',
        borderBottom: `solid 1px ${theme.palette.divider}`,
        [theme.breakpoints.down('xs')]: { display: 'block' },
        '&.fade-enter': {
          opacity: 0.01,
          transform: 'translateX(100vw)',
        },
        '&.fade-enter-active': {
          opacity: 1,
          transform: 'translateX(0)',
          transition: 'all 500ms ease-in',
        },
        '&.fade-exit': {
          opacity: 1,
          transform: 'translateX(0)',
        },
        '&.fade-exit-active': {
          opacity: 0.01,
          transform: 'translateX(100vw)',
          transition: 'all 500ms ease-in',
        },
      },
      index: {
        [theme.breakpoints.down('sm')]: { display: 'none' },
        marginRight: theme.spacing(1),
      },
      indexContainer: {
        display: 'inline-flex',
        paddingTop: '1em',
        marginRight: theme.spacing(1),
        alignItems: 'center',
      },
      form: {
        flex: 2,
        display: 'inline-flex',
        gap: '16px',
        [theme.breakpoints.down('xs')]: { display: 'block' },
      },
      action: {
        paddingTop: '0.5em',
        '& .button-add': {
          backgroundColor: '#87dc90',
        },
      },
      leftIcon: {
        marginRight: theme.spacing(1),
      },
    }),
    { name: 'RaSimpleFormIterator' }
  );

const ProductFilter = (props) => (
  <Filter {...props}>
    <ReferenceInput variant="outlined" label="دسته " source="productCategoryId" reference="productCategory" alwaysOn>
      <SelectInput optionText="title" />
    </ReferenceInput>
    <SearchInput variant="outlined" resettable source="q" alwaysOn />
  </Filter>
);
const useStyles = (width) => makeStyles({ image: { width } })();

export const ProductList = (props) => {
  const classes = useStyles(100);

  return (
    <List {...props} perPage={100} sort={{ field: 'order', order: 'ASC' }} filter={{productPage:true}} filters={<ProductFilter />}>
      {isMobile ? (
        <Datagrid rowClick="show">
          <TextField source="title" />
          <TextField source="price" />

          <ImageField source="icon" classes={classes} />
        </Datagrid>
      ) : (

        <Datagrid rowClick="show">
          <TextField source="order" />
          <TextField source="title" />
          <TextField source="price" />
          <BooleanField source="invisiable" />
          <ImageField source="icon" />
          {/* <TextField source="objectId"/> */}
          <ReferenceField link={null} label="دسته محصول" source="productCategoryId" reference="productCategory" >
            <TextField source="title" />
          </ReferenceField>
        </Datagrid>
      )}
    </List>
  )
};

export const ProductEdit = (props) => {
  const classes = useSimpleFormStyleList(props);
  const diverClass = useDividerStyleList(props);

  return (
    <Edit mutationMode="pessimistic" {...props} undoable={false} actions={<EditActions noDel={true} />}>
      <SimpleForm submitOnEnter={false} variant="outlined" toolbar={<EditFormActions />}>
        <ReferenceInput label="دسته محصول" validate={required()} source="productCategoryId" reference="productCategory">
          <SelectInput optionText="title" />
        </ReferenceInput>
        <TextInput source="title" validate={required()} />
        <SelectInput
            source="productType"
            label="نوع محصول"
            defaultValue="finalProduct"
            validate={required()}
            choices={[
              { id: 'finalProduct', name: 'محصول نهایی' },
                { id: 'rawMaterial', name: 'مواد اولیه' },
                { id: 'innerProduct', name: 'محصول خط تولید' }, // Third choice description
            ]}
            style={{ width: '250px', marginBottom: '16px' }}
        />
        <Divider classes={diverClass} />
        <ArrayInput source="productUnitMaps" label="نوع محصول در واحد ها (خروجی یا ورودی)">
          <SimpleFormIterator
            classes={classes}
            TransitionProps={{ enter: false, exit: false }}  >
            <ReferenceInput label="در واحد" source="unit" reference="unit" >
              <SelectInput optionText="title" style={{ width: '190px' }} />
            </ReferenceInput>
            <BooleanInput label="ورودی است؟" source="isInput" style={{ width: '140px' }} />
          </SimpleFormIterator>
        </ArrayInput>
        <Divider classes={diverClass} />

        <ArrayInput source="productPackages" label="بسته‌بندی‌ها">
          <SimpleFormIterator
            classes={classes}
            TransitionProps={{ enter: false, exit: false }}  >
            <TextInput label="عنوان" source="title" />
            <ReferenceInput label="در بسته‌ی" source="productUnit" reference="productUnit" >
              <SelectInput optionText="title" style={{ width: '190px' }} />
            </ReferenceInput>
            <TextInput label="وزن" source="weight" style={{ width: '90px' }} />
            <ReferenceInput label="واحد" source="unit" reference="baseUnit" >
              <SelectInput optionText="title" style={{ width: '90px' }} />
            </ReferenceInput>
          </SimpleFormIterator>
        </ArrayInput>
        {/* <Divider classes={diverClass} />
        <TextInput label="به ازای" source="productRawMaterialBase.base" />
        <ReferenceInput label="واحد" source="productRawMaterialBase.unit" reference="baseUnit" >
          <SelectInput optionText="title" />
        </ReferenceInput> */}
        <Divider classes={diverClass} />

        <ArrayInput source="productRawMaterials" label="مواد اولیه" >
          <SimpleFormIterator classes={classes} disableReordering TransitionProps={{ enter: false, exit: false }}  >
            <ReferenceInput filter={{"productType":["rawMaterial","innerProduct"]}} label="ماده اولیه" source="product" reference="product" >
              <SelectInput optionText="title" />
            </ReferenceInput>

            <TextInput label="مقدار" source="required" style={{ width: '120px' }} />
            <ReferenceInput label="واحد" source="unit" reference="baseUnit"  >
              <SelectInput optionText="title" style={{ width: '90px' }} />
            </ReferenceInput>
          </SimpleFormIterator>
        </ArrayInput>
        <Divider classes={diverClass} />

        <TextInput source="referenceUrl" />
        <NumberInput source="order" validate={required()} />
        <TextInput source="price" />
        <NumberInput source="sku" />

        <TextInput source="description" label="توضیحات" />
        <ImageInput source="pictures" label="تصویر مربوطه" accept="image/*">
          <ImageField source="src" title="title" />
        </ImageInput>
        <TextInput source="icon" />
        <BooleanInput source="invisiable" label="عدم نمایش" />
      </SimpleForm>
    </Edit >
  )
};

export const ProductShow = (props) => (
  <ShowView {...props} className="overflow-auto">
    <SimpleShowLayout className="grid grid-flow-row grid-cols-2">
      <TextField source="order" className=" col-span-2"/>
      <ImageField source="icon" className=" col-span-2" />
      <TextField source="title" />
      <TextField source="price" />
      <TextField source="sku" />

      <TextField source="description" />
      <DateField locales={"fa-IR"} source="createdAt" />
      <DateField locales={"fa-IR"} source="updatedAt" />
      {/* <UrlField source="referenceUrl" /> */}
      <ReferenceField link="show" label="دسته محصول" source="productCategoryId" reference="productCategory" >
        <TextField source="title" />
      </ReferenceField>
      <TextField source="objectId" />
    </SimpleShowLayout>
  </ShowView>
);

export const ProductCreate = (props) => {
  const classes = useSimpleFormStyleList(props);
  const diverClass = useDividerStyleList(props);

  return (
    <CreateView {...props}>
      <ReferenceInput label="دسته محصول" source="productCategoryId" validate={required()} reference="productCategory">
        <SelectInput optionText="title" />
      </ReferenceInput>
      <TextInput source="title" validate={required()} />
      <TextInput source="referenceUrl" />
      <NumberInput source="order" validate={required()} />
      <TextInput source="price" validate={required()} />
      <NumberInput source="sku" />
      <Divider classes={diverClass} />
      <ArrayInput source="productPackages" label="بسته‌بندی‌ها">
        <SimpleFormIterator
          classes={classes}
          TransitionProps={{ enter: false, exit: false }}  >
          <TextInput label="عنوان" source="title" />
          <ReferenceInput label="نوع بسته‌بندی" source="productUnit" reference="productUnit" >
            <SelectInput optionText="title" style={{ width: '190px' }} />
          </ReferenceInput>
          <TextInput label="وزن" source="weight" style={{ width: '90px' }} />
          <ReferenceInput label="واحد" source="unit" reference="baseUnit" >
            <SelectInput optionText="title" style={{ width: '90px' }} />
          </ReferenceInput>
        </SimpleFormIterator>
      </ArrayInput>
      <Divider classes={diverClass} />
      <TextInput label="به ازای" source="productRawMaterialBase.base" />
      <ReferenceInput label="واحد" source="productRawMaterialBase.unit" reference="baseUnit" >
        <SelectInput optionText="title" />
      </ReferenceInput>

      <ArrayInput source="productRawMaterials" label="مواد اولیه" >
        <SimpleFormIterator classes={classes} disableReordering TransitionProps={{ enter: false, exit: false }}  >
          <ReferenceInput label="ماده اولیه" source="rawMaterial" reference="rawMaterial" >
            <SelectInput optionText="title" />
          </ReferenceInput>

          <TextInput label="مقدار" source="required" style={{ width: '120px' }} />
          <ReferenceInput label="واحد" source="unit" reference="baseUnit"  >
            <SelectInput optionText="title" style={{ width: '90px' }} />
          </ReferenceInput>
        </SimpleFormIterator>
      </ArrayInput>
      <Divider classes={diverClass} />
      <TextInput source="description" label="توضیحات" />
      <ImageInput source="pictures" label="تصویر مربوطه" accept="image/*">
        <ImageField source="src" title="title" />
      </ImageInput>
    </CreateView>
  )
};
